module.exports = __webpack_public_path__ + "tab-burger-menu.3b0afaeca40955e306622db19fe5b3bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab-burger-menu.svg
// module id = 1160
// module chunks = 0